module.exports = __webpack_public_path__ + "img/deleteButton.21240cc9.svg";